export enum GlobalEvouchersRoutes {
  BASE = 'evouchers',
  EVOUCHER_LOGIN = 'evoucherlogin'
}
